export const lazyReload = (fn) =>
  new Promise((resolve) => {
    fn()
      .then(resolve)
      .catch(() => {
        window.location.reload();
      });
  });
